import { useEffect } from "react";

const scripts = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "五一爆料",
    url: "https://kuai688.cn/",
    inLanguage: "zh-CN",
    description: "聚焦五一劳动节假期安排、调休争议、节日消费陷阱与景区套路的独立观察与避坑指南平台。",
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "五一爆料",
    url: "https://kuai688.cn/",
    logo: "https://kuai688.cn/favicon.ico",
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "核心专题",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "调休争议" },
      { "@type": "ListItem", position: 2, name: "假期黑幕" },
      { "@type": "ListItem", position: 3, name: "景区套路" },
      { "@type": "ListItem", position: 4, name: "消费陷阱" },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "五一是法定节假日吗？调休又是怎么回事？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "劳动节(5月1日)是法定节假日，法律规定放假一天。所谓'五一假期'往往是把法定假日与周末、以及通过调休(前后周末补班)拼凑出来的连休。",
        },
      },
      {
        "@type": "Question",
        name: "为什么景区一到五一就'限流'，门票反而更难买？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "限流本质是保障安全与游览体验的管理措施，但热门景区承载量有限，叠加节假日集中出行，供需失衡自然推高抢票难度。建议通过官方渠道预约。",
        },
      },
      {
        "@type": "Question",
        name: "遇到景区或商家节假日涨价、捆绑销售，怎么维权？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "先保留付款凭证与订单截图，再拨打12345或12315向市场监管部门反映。若涉及价格明显高于标价、虚假宣传或强制交易，说明时间地点诉求即可受理。",
        },
      },
      {
        "@type": "Question",
        name: "'低价一日游'为什么便宜得离谱？能信吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "极低价往往通过引导购物、返点抽成来弥补成本，本质是'购物团'。出行前建议核实旅行社资质与合同条款，明确有无购物安排。",
        },
      },
    ],
  },
];

export default function JsonLd() {
  useEffect(() => {
    const tags = scripts.map((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      return s;
    });
    return () => {
      tags.forEach((s) => s.remove());
    };
  }, []);
  return null;
}